/**
 * Check if the device is iOS
 * @returns {boolean} true si l'appareil est iOS (iPad, iPhone, iPod)
 */
export const _isIOS = () => {
  if (typeof navigator === 'undefined')
    return false;

  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  // Classic iPhone / iPad / iPod
  if (/iPad|iPhone|iPod/.test(ua))
    return true;

  // iPadOS pretending to be a Mac
  const isMacLike = /Macintosh/.test(ua) || /MacIntel/.test(platform);

  // Very likely an iPad
  if (isMacLike && maxTouchPoints > 1)
    return true;

  return false;
};

/**
 * Check if the application is in an iOS WebView
 * @returns {boolean} true if the app is in an iOS WebView (not Safari)
 */
export const isInWebView = () => {
  // We try to systematically inject a window property in our iOS apps
  // otherwise we fallback to the classic user agent detection
  if (window?.IS_NATIVE_WEBVIEW === true)
    return true;

  if (typeof navigator === 'undefined')
    return false;

  return _isIOS() && !/Safari/.test(navigator.userAgent || '');
};